import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';

import EmisorSeriesList from './EmisorSeriesList';
import EmisorSeriesUpsertForm from './EmisorSeriesUpsertForm';

class EmisorSeriesManager extends Component {
  componentDidMount() {
    this.props.onFormDataChange({
      data: {
        series: this.props.data,
      },
      step: this.props.step,
      isValid: true,
    });
  }

  handleOnAddSerie = (data) => {
    const duplicate = this.props.data.find(
      (item) => item.tipo === data.tipo && item.serie.toLowerCase() === data.serie.toLowerCase()
    );

    if (!duplicate) {
      this.props.onFormDataChange({
        data: {
          series: this.props.data.concat([data]),
        },
        step: this.props.step,
        isValid: true,
      });
    } else {
      const series = this.props.data.map((item) => {
        if (item.id === duplicate.id) {
          item.action = 'update';
          item.folio = data.folio;
        }

        return item;
      });

      this.props.onFormDataChange({
        data: {
          series: series,
        },
        step: this.props.step,
        isValid: true,
      });
    }
  };

  handleOnDataChange = (data) => {
    this.props.onFormDataChange({
      data: {
        series: data,
      },
      step: this.props.step,
      isValid: true,
    });
  };

  render() {
    const { data = [] } = this.props;

    return (
      <>
        <Row>
          <Col xs={12}>
            <Row>
              <Col className="mb-3 mt-1">
                <strong>Nueva Serie</strong>
              </Col>
            </Row>

            <EmisorSeriesUpsertForm onAdd={this.handleOnAddSerie} />
          </Col>
        </Row>

        <Row>
          <Col
            xs={12}
            sm={12}
            md={6}
          >
            <Row>
              <Col className="mb-3 mt-1">
                <strong>Series</strong>
              </Col>
            </Row>

            <EmisorSeriesList
              data={data}
              onDataChange={this.handleOnDataChange}
            />
          </Col>
        </Row>
      </>
    );
  }
}

export default EmisorSeriesManager;
